export const anchorScrolling = () => {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (event) {
      console.log('scrolling works');
      event.preventDefault();

      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        const offset = 1;
        const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;

        const startPosition = window.pageYOffset;
        const distance = elementPosition - startPosition;
        const duration = 1500;
        let startTime = null;

        function animation(currentTime) {
          if (!startTime) startTime = currentTime;
          const timeElapsed = currentTime - startTime;
          const progress = Math.min(timeElapsed / duration, 1);
          
          const ease = 1 - Math.pow(1 - progress, 4);
          
          window.scrollTo(0, startPosition + (distance * ease));

          if (timeElapsed < duration) {
            requestAnimationFrame(animation);
          }
        }

        requestAnimationFrame(animation);
      }
    });
  });
};